import { StateCreator } from 'zustand';

export interface ToolbarSlice {
  toolbarTitle: string;
  setToolbarTitle: (toolbarTitle: string) => void;
}

export const toolbarSlice: StateCreator<ToolbarSlice, [], [], ToolbarSlice> = (
  set,
) => ({
  toolbarTitle: '',
  setToolbarTitle: (toolbarTitle: string) => set({ toolbarTitle }),
});
